import Dispatcher from 'shared/utils/dispatcher'

// Update Dispatcher.send method
Dispatcher.send = (eventName: string, data: unknown) =>
  Dispatcher.dispatch({
    eventName,
    data,
  })

// Prevent iPhone from scrolling / overscrolling or resizing
document.addEventListener('gesturestart', (e) => e.preventDefault())
document.addEventListener('touchmove', (e) => e.preventDefault())
